import { Alert, Box, Breadcrumbs, Chip, Paper, Stack, Typography } from '@mui/material'
import { Construction } from '@mui/icons-material'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { findNavItem } from '../app/navigation'

/**
 * Ecran nescris încă. Arată explicit ce urmează să fie aici și în ce fază, în loc
 * de o pagină goală — structura completă a aplicației este vizibilă din prima zi.
 */
export default function Placeholder() {
  const { t } = useTranslation()
  const location = useLocation()
  const found = findNavItem(location.pathname)

  return (
    <Stack spacing={2}>
      <Breadcrumbs separator="/" sx={{ fontSize: 12.5 }}>
        <Typography variant="inherit" color="text.secondary">{found?.group.label ?? '—'}</Typography>
        <Typography variant="inherit" color="text.primary">{found?.item.label ?? location.pathname}</Typography>
      </Breadcrumbs>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
        <Typography variant="h2">{found?.item.label ?? 'Ecran'}</Typography>
        {found && found.item.phase > 1 && (
          <Chip size="small" color="info" variant="outlined"
            label={found.item.phase === 2 ? t('common.phase2') : t('common.phase3')} />
        )}
      </Box>

      <Paper variant="outlined" sx={{ p: 4 }}>
        <Alert severity="info" icon={<Construction />} variant="outlined">
          <Typography variant="body2" sx={{ fontWeight: 600 }}>{t('screen.notImplemented')}</Typography>
          {found && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Permisiune necesară: <code>{found.item.permission}</code>
            </Typography>
          )}
        </Alert>
      </Paper>
    </Stack>
  )
}
